import React from "react";
import { useSnackbar } from "../../ui-components/snackbarProvider";

// material import
import { Box, Button, Card, Grid2, Typography } from "@mui/material";

// project import
import AdminDBServices from "../../services/v1/adminDBServices";

const ActiveDonor = ({
  selectedRow,
  fetchAllDonations,
  fetchAllInactiveDonors,
  handleCloseDialog,
}) => {
  const { showSnackbar } = useSnackbar();

  const handleDonorStatusChange = async () => {
    try {
      const response = await AdminDBServices.changeDonorStatus(
        selectedRow.donorID
      );

      console.log("API Response:", response);
      const message =
        response.data?.message ||
        response.message ||
        "Donor status changed successfully.";

      showSnackbar(message, {
        severity: "success",
      });
      fetchAllDonations();
      fetchAllInactiveDonors();
      handleCloseDialog();
    } catch (error) {
      console.error("Error changing donor status:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to change donor status.";
      showSnackbar(errorMessage, {
        severity: "error",
      });
    }
  };

  return (
    <Box sx={{ border: 1, borderRadius: 2, borderColor: "lightgray" }}>
      <Grid2 item size={{ xs: 12 }} sx={{ my: 1 }}>
        <Grid2 container spacing={1} p={3}>
          <Grid2 item size={{ xs: 5.8 }}>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Donor Name
            </Typography>
          </Grid2>
          <Grid2 item size={{ xs: 5.8 }}>
            <Typography variant="body2">
              {selectedRow?.title} {selectedRow?.donorName}
            </Typography>
          </Grid2>
          <Grid2 item size={{ xs: 0.4 }} />

          <Grid2 item size={{ xs: 5.8 }}>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Email
            </Typography>
          </Grid2>
          <Grid2 item size={{ xs: 5.8 }}>
            <Typography variant="body2">{selectedRow?.email}</Typography>
          </Grid2>
          <Grid2 item size={{ xs: 0.4 }} />

          <Grid2 item size={{ xs: 5.8 }}>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              City
            </Typography>
          </Grid2>
          <Grid2 item size={{ xs: 5.8 }}>
            <Typography variant="body2">{selectedRow?.city}</Typography>
          </Grid2>
          <Grid2 item size={{ xs: 0.4 }} />

          <Grid2 item size={{ xs: 5.8 }}>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Country
            </Typography>
          </Grid2>
          <Grid2 item size={{ xs: 5.8 }}>
            <Typography variant="body2">{selectedRow?.country}</Typography>
          </Grid2>
          <Grid2 item size={{ xs: 0.4 }} />

          <Grid2 item size={{ xs: 5.8 }}>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Type
            </Typography>
          </Grid2>
          <Grid2 item size={{ xs: 5.8 }}>
            <Typography variant="body2">{selectedRow?.type || "-"}</Typography>
          </Grid2>

          <Grid2 item size={{ xs: 0.4 }} />

          <Grid2 item size={{ xs: 5.8 }}>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Frequency
            </Typography>
          </Grid2>
          <Grid2 item size={{ xs: 5.8 }}>
            <Typography variant="body2">{selectedRow?.frequency}</Typography>
          </Grid2>

          <Grid2 item size={{ xs: 0.4 }} />

          {/* <Grid2 item size={{ xs: 5.8 }}>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Recurring Ends
            </Typography>
          </Grid2>
          <Grid2 item size={{ xs: 5.8 }}>
            <Typography variant="body2">22-01-2026</Typography>
          </Grid2>

          <Grid2 item size={{ xs: 0.4 }} /> */}

          <Grid2 item size={{ xs: 5.8 }}>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Purpose for Sponsoring
            </Typography>
          </Grid2>
          <Grid2 item size={{ xs: 5.8 }}>
            <Typography variant="body2">{selectedRow?.message}</Typography>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2
        item
        size={{ xs: 12 }}
        container
        justifyContent="flex-end"
        spacing={1}
        mb={2}
        mr={2}
      >
        <Grid2 item size={{ xs: 3.5 }}>
          <Button
            size="small"
            fullWidth
            variant="outlined"
            color="secondary"
            onClick={handleDonorStatusChange}
          >
            Active Donor
          </Button>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default ActiveDonor;
